import TimeAgo from '@cp/src/components/TimeAgo';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { RootState } from '@cp/src/store';
import { getSanitizedEnumValue, pluralisation } from '@cp/src/utils/commonUtils';
import { Tag, Typography } from '@navi/web-ui/lib/primitives';
import { useDispatch, useSelector } from 'react-redux';
import { acknowledgeTicket, fetchSingleTicket } from '../../actions/CsaTicketingActions';
import { TicketStatusMap } from '../../constants';
import { setRequestRaised, setRequestReceived } from '../../reducers/CsaTicketingSlice';
import { IRequestTicket } from '../../types';
import { getTagColor } from '../../utils';
import styles from './index.module.scss';

const RequestTicket = (props: IRequestTicket) => {
  const { ticket, showDashedLine, toggleTicketDrawer, isReceivedTicket = false } = props;
  const {
    referenceId,
    status,
    isAcknowledgedByAssignee,
    newUpdatesCount,
    requestTypeLabel,
    createdAt
  } = ticket;

  const dispatch = useDispatch();

  const requestRaised = useSelector(
    (state: RootState) => state?.csaTicketing?.requestRaised?.tickets
  );
  const requestReceived = useSelector(
    (state: RootState) => state?.csaTicketing?.requestReceived?.tickets
  );

  const ticketClickHandler = () => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_TASK_DETAIL_CLICKED, {
      ticketId: referenceId
    });
    if (!isAcknowledgedByAssignee || newUpdatesCount) {
      acknowledgeTicket(referenceId, () => {
        const ticketsData = isReceivedTicket ? [...requestReceived] : [...requestRaised];
        const ticketIndex = ticketsData?.findIndex(
          ticketData => ticketData?.referenceId === referenceId
        );
        if (ticketIndex !== -1) {
          ticketsData[ticketIndex] = {
            ...ticket,
            isAcknowledgedByAssignee: isReceivedTicket ? true : ticket?.isAcknowledgedByAssignee,
            newUpdatesCount: 0
          };
          if (isReceivedTicket) {
            dispatch(setRequestReceived(ticketsData));
          } else {
            dispatch(setRequestRaised(ticketsData));
          }
        }
      });
    }
    dispatch(fetchSingleTicket(referenceId));
    toggleTicketDrawer();
  };

  return (
    <div onClick={ticketClickHandler}>
      <div className={styles.requestTicketWrapper}>
        <div>
          {newUpdatesCount ? (
            <Typography variant="h6" color="#518CFF">
              {newUpdatesCount} {pluralisation('update', newUpdatesCount, 's')}
            </Typography>
          ) : null}
          <div className="flex items-center gap-2">
            {!isAcknowledgedByAssignee && isReceivedTicket ? (
              <div className={styles.newTicket} />
            ) : null}
            <Typography
              variant="h4"
              color="var(--navi-color-gray-c1)"
              className="font-normal max-w-[120px] truncate"
            >
              {requestTypeLabel}
            </Typography>
          </div>
          <TimeAgo
            epoch={createdAt}
            ellipsisClass={styles.ellipsisClass}
            hideTooltipWhenDiffIsOneDay
          />
        </div>
        <Tag
          color={getTagColor(status)}
          variant="transparent"
          label={getSanitizedEnumValue(TicketStatusMap, status)}
        />
      </div>
      {showDashedLine ? <div className="border border-dashed border-[#EDEDED] mx-2" /> : null}
    </div>
  );
};

export default RequestTicket;
